const newVersionRate = 0.65
const key = 'tuoCkAbTestingFlag'
const newFlag = 'new'
const oldFlag = 'old'

export const create = () => {
    let flag = window.localStorage.getItem(key)
    if (flag === newFlag) {
        return true
    }
    if (flag === oldFlag) {
        return false
    }

    flag = Math.random() < newVersionRate ? newFlag : oldFlag
    window.localStorage.setItem(key, flag)
    return flag === newFlag
}

export const get = () => {
    let flag = window.localStorage.getItem(key)
    return flag === newFlag
}

export const clean = () => {
    window.localStorage.removeItem(key)
}

export const saveAll = () => {
    const newUiSignature = [
        'active-kids',
        'poi-acceptance.apps.pcf-ext.testservicensw.net'
    ]

    const url = window.location.href

    for (let i = 0; i < newUiSignature.length; i++) {
        if (url.includes(newUiSignature[i])) {
            return true
        }
    }
    return false
}
